import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/authenticate/reset-password")({
  component: RouteComponent,
  validateSearch: (search: {
    token: string
    userId: number
    userName: string
  }) => ({
    ...search,
  }),
})

import { Text } from "@mantine/core"
import { useTranslation } from "react-i18next"
import { SuccessAlert } from "../../-components/success-alert"
import { AuthContainer } from "./-components/auth-container"
import { ChangePasswordWithTokenForm } from "./-components/change-password-with-token-form"
import { Link } from "../../-components/link"

function RouteComponent() {
  const { token, userId, userName } = Route.useSearch()

  const [sucessfullySet, setSucessfullySet] = React.useState(false)
  const { t } = useTranslation("app_server")
  return (
    <AuthContainer
      title={t("ResetPassword")}
      description={
        <Text c="dimmed" size="sm" ta="center" mt={5}>
          {t("Authenticate_ResetPassword_Description")}
        </Text>
      }
    >
      {sucessfullySet ? (
        <SuccessAlert
          title={t("Success")}
          description={t("Authenticate_ResetPassword_SuccessAlertDescription")}
        >
          <Link linkText={t("ToTheApp")} navigateOptions={{ to: "/app" }} />
        </SuccessAlert>
      ) : (
        <ChangePasswordWithTokenForm
          userId={userId}
          userName={userName}
          token={token}
          onSuccess={() => setSucessfullySet(true)}
        />
      )}
    </AuthContainer>
  )
}
